import { cn } from "@/lib/utils";
import { TimePeriod } from "@/lib/metal-price";

interface ChartPeriodSelectorProps {
  selectedPeriod: TimePeriod;
  isLoading: boolean;
  onPeriodChange: (period: TimePeriod) => void;
  disabledPeriods?: TimePeriod[];
}

export function ChartPeriodSelector({ 
  selectedPeriod, 
  isLoading, 
  onPeriodChange,
  disabledPeriods = []
}: ChartPeriodSelectorProps) {
  const periods: TimePeriod[] = ["week", "month", "year", "all"];
  const periodLabels: Record<TimePeriod, string> = {
    week: "Settimana",
    month: "Mese",
    year: "Anno",
    all: "Tutto"
  };

  return (
    <div className="flex flex-wrap gap-1.5">
      {periods.map((period) => {
        const isDisabled = isLoading || disabledPeriods.includes(period);
        
        return (
          <button
            key={period}
            onClick={() => !isDisabled && onPeriodChange(period)}
            disabled={isDisabled}
            className={cn(
              "px-3 py-1.5 text-xs rounded-full transition-colors font-medium shadow-sm",
              selectedPeriod === period
                ? "metal-accent text-white"
                : "bg-secondary hover:bg-secondary/80 hover:scale-105 transition-transform",
              isDisabled && "opacity-40 cursor-not-allowed"
            )}
            title={isDisabled && period !== selectedPeriod ? "Nessun dato disponibile" : undefined}
          >
            {periodLabels[period]}
            {isLoading && selectedPeriod === period && (
              <span className="ml-1 inline-block animate-spin">⟳</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
